import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 3%;
  overflow: auto;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      color: var(--blueDark);
    }

    > div {
      display: flex;
      flex-direction: column;
      text-align: right;
      font-weight: 500;
    }
  }

  .centerText {
    display: flex;
    padding-top: 5%;
    align-items: center;
    flex-direction: column;

    span {
      font-size: 1.3rem;
      font-weight: 600;
      color: var(--greenDark);
    }

    a {
      font-size: 1.3rem;
      font-weight: 600;
      color: var(--blueUrl);
      text-decoration: underline;
      cursor: pointer;
    }

    a:hover {
      color: ${darken(0.2, '#94d3fe')};
    }
  }

  textarea {
    resize: none;
    border: 1px solid var(--gray);
    border-radius: 10px;
    min-height: 100px;
    padding: 5px 15px;
    margin: 10px 0 10px 0;
    color: var(--black);
    font-size: 16px;
  }

  button {
    background: var(--yellowDark);
    color: var(--blueDark);
    border-radius: 10px;
    padding: 5px 10px;
    margin-top: 30px;
    margin-bottom: 15px;
    font-weight: bold;
    box-shadow: 2px 2px 2px rgba(12, 13, 14, 0.15);
    transition: background 0.2s;
    width: 80px;

    &:hover {
      background: ${darken(0.06, '#f7c325')};
    }
  }

  form {
    display: flex;
    flex-direction: column;

    .fieldContainer {
      display: flex;
      justify-content: space-between;
    }

    .buttonContainer {
      display: flex;
      justify-content: center;
    }

    input {
      border: 1px solid var(--gray);
      border-radius: 10px;
      height: 40px;
      padding: 0 15px;
      margin: 10px 0 10px 0;
      color: var(--black);

      &::placeholder {
        color: var(--gray);
      }
    }
  }
`;

export const Info = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  h1 {
    color: var(--blueDark);
  }

  > div {
    display: flex;
    flex-direction: column;
    text-align: right;
    font-weight: 500;
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid #767676;
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;
